// Accettando un preventivo si chiede se il lavoro include le fasi "da chiedere" del flusso
// (rifilo, montaggio e installazione…). Le risposte vanno sul lavoro che nasce; chi non sa ancora
// può decidere dopo, dal lavoro: il flusso si ferma a quella fase e lo chiede di nuovo.
// Montato una volta in App; si apre con chiediFasiIncluse() (promessa con le risposte o null).
import React, { useEffect, useState } from 'react';
import { Button, ButtonGroup, Modal } from 'react-bootstrap';
import { FaExternalLinkAlt } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const EVENTO = 'psc:chiediFasiIncluse';

/** Apre la domanda e risolve con { "<stato_id>": true|false } oppure null se si decide dopo. */
export const chiediFasiIncluse = (info) => new Promise(resolve => {
    window.dispatchEvent(new CustomEvent(EVENTO, { detail: { info, resolve } }));
});

const FasiDaChiedereModal = () => {
    const { t } = useTranslation();
    const [richiesta, setRichiesta] = useState(null);
    const [risposte, setRisposte] = useState({});

    useEffect(() => {
        const apri = (e) => {
            const iniziali = {};
            for (const f of e.detail.info.fasi) if (typeof f.inclusa === 'boolean') iniziali[f.stato_id] = f.inclusa;
            setRisposte(iniziali);
            setRichiesta(e.detail);
        };
        window.addEventListener(EVENTO, apri);
        return () => window.removeEventListener(EVENTO, apri);
    }, []);

    const chiudi = (valore) => {
        richiesta?.resolve(valore);
        setRichiesta(null);
    };

    if (!richiesta) return null;
    const fasi = richiesta.info.fasi;
    const tutte = fasi.every(f => typeof risposte[f.stato_id] === 'boolean');

    return (
        <Modal show centered onHide={() => chiudi(Object.keys(risposte).length ? risposte : null)}>
            <Modal.Header closeButton>
                <Modal.Title as="h5">{t('flusso.accept_title')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="text-muted small">{t('flusso.accept_desc')}</p>
                {fasi.map(f => (
                    <div key={f.stato_id} className="d-flex align-items-center justify-content-between gap-2 py-2 border-top">
                        <span className="fw-semibold">
                            {f.nome}
                            {f.esterno && <span className="text-muted small fw-normal ms-2"><FaExternalLinkAlt className="me-1" />{t('flusso.external')}</span>}
                        </span>
                        <ButtonGroup size="sm" role="radiogroup" aria-label={f.nome}>
                            <Button variant={risposte[f.stato_id] === true ? 'success' : 'outline-success'} aria-pressed={risposte[f.stato_id] === true}
                                    onClick={() => setRisposte(r => ({ ...r, [f.stato_id]: true }))}>{t('flusso.yes')}</Button>
                            <Button variant={risposte[f.stato_id] === false ? 'secondary' : 'outline-secondary'} aria-pressed={risposte[f.stato_id] === false}
                                    onClick={() => setRisposte(r => ({ ...r, [f.stato_id]: false }))}>{t('flusso.no')}</Button>
                        </ButtonGroup>
                    </div>
                ))}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="link" className="text-muted me-auto" onClick={() => chiudi(Object.keys(risposte).length ? risposte : null)}>{t('flusso.decide_later')}</Button>
                <Button variant="primary" disabled={!tutte} onClick={() => chiudi(risposte)}>{t('flusso.accept_confirm')}</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default FasiDaChiedereModal;
